import { Container } from '@angular/compiler/src/i18n/i18n_ast';
import { RecordsCoudPouce } from '@classes/records/record';
import { Pagination } from './pagination';

export class PaginationResp {
    body: RecordsCoudPouce[];
    pagination: Pagination;

    constructor(
        body: RecordsCoudPouce[],
        pagination: string
    ) {
        this.body = body;
        this.pagination = JSON.parse(pagination);
    }
}
export class PaginationRespContainer {
    body: Container[];
    pagination: Pagination;

    constructor(
        body: Container[],
        pagination: string
    ) {
        this.body = body;
        this.pagination = JSON.parse(pagination);
    }
}
